import { Condition } from '@codegen';
import {
  ConditionsAction,
  ConditionsTypes,
} from '@modules/conditions/store/conditions.action';
import { AppState } from '@modules/shared/store';
import { createSelector } from '@ngrx/store';

export class ConditionsState {
  public currentProposalCondition: string;
  public conditions: Array<Condition>;
  public defaultCondition: Condition | null;
}

export function reducer(
  state = new ConditionsState(),
  action: ConditionsAction
): ConditionsState {
  switch (action.type) {
    case ConditionsTypes.SetProposalConditions:
      return {
        ...state,
        conditions: action.payload,
      };
    case ConditionsTypes.SelectProposalCondition:
      return {
        ...state,
        currentProposalCondition: action.payload,
      };
    case ConditionsTypes.SetDefaultCondition:
      return {
        ...state,
        defaultCondition: action.readonly,
      };
    default: {
      return state;
    }
  }
}

export const getConditionsState = (state: AppState): ConditionsState =>
  state.conditions;
export const getConditions = createSelector(
  getConditionsState,
  (state: ConditionsState) => state.conditions
);
